import _ from 'lodash';
import React from 'react';
import { CryptoIcon } from 'components/CryptoIcon';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Box, Text } from 'components/Wrapped';
import styles from './currency.module.scss';

const CurrencyInfo = ({ currency, currencies, hasFullName, onlyFullName, withLink, hasIcon }) => {
  const currencyFullName = () => {
    return hasFullName ? _.get(currencies, `${currency}.fullName`) : currency;
  };

  const isFiat = _.startsWith(_.get(currencies[currency], 'walletType'), 'Fiat');

  const isSecurityToken = _.get(currencies, `${currency}.walletType`) === 'SecurityToken';

  const currencyInfo =
    !isFiat && !isSecurityToken ? (
      <Box pad="none" direction="row" gap="xxsmall" align="center" className={styles.flxflow}>
        <Box pad="none" direction="row" gap="xsmall" align="center" className={styles.flxflow}>
          {hasIcon && <CryptoIcon currency={currency} marginRight="1px" />}
          {withLink && (
            <Link to={`/currencies/${currency}`}>
              <Box pad="none">
                <Text color="text" hoverColor="primary" margin={{ right: 'xxsmall' }}>
                  {currency}
                </Text>
                <Text color="text" hoverColor="primary" size="xsmall" style={{ opacity: 0.6 }}>
                  {currencyFullName()}
                </Text>
              </Box>
            </Link>
          )}
          {!withLink && (
            <Box pad="none">
              <Text color="text" margin={{ right: 'xxsmall' }}>
                {currency}
              </Text>
              <Text color="text" size="xsmall" style={{ opacity: 0.6 }}>
                {currencyFullName()}
              </Text>
            </Box>
          )}
        </Box>
      </Box>
    ) : (
      <Box pad="none" direction="row" gap="xsmall" align="center" className={styles.flxflow}>
        {hasIcon && <CryptoIcon currency={currency} />}
        <Box pad="none">
          <Text color="text">{currency}</Text>
          <Text color="text" size="xsmall" style={{ opacity: 0.6 }}>
            {currencyFullName()}
          </Text>
        </Box>
      </Box>
    );

  return currencyInfo;
};

const mapStateToProps = ({ exchangeSettings }) => ({
  currencies: exchangeSettings.currencySettings,
});

CurrencyInfo.propTypes = {
  currency: PropTypes.string.isRequired,
  currencies: PropTypes.object.isRequired,
  hasFullName: PropTypes.bool.isRequired,
  hasIcon: PropTypes.bool.isRequired,
  withLink: PropTypes.bool.isRequired,
};

CurrencyInfo.defaultProps = {
  hasIcon: false,
  hasFullName: false,
  withLink: true,
};

export default connect(mapStateToProps, null)(CurrencyInfo);
